(function () {
  'use strict';

  var GEO_MARKETS = {
    ro: {
      domain: 'charlotteshape.ro',
      storageKey: 'charlotte_geo_ro_closed'
    },
    fr: {
      domain: 'charlotteshape.fr',
      storageKey: 'charlotte_geo_fr_closed'
    },
    it: {
      domain: 'charlotteshape.it',
      storageKey: 'charlotte_geo_it_closed'
    },
    intl: {
      domain: 'charlotteshape.com',
      storageKey: 'charlotte_geo_intl_closed'
    }
  };

  var STORAGE_KEYS = {
    choiceSaved: 'charlotte_geo_choice_saved',
    selectedMarket: 'charlotte_geo_selected_market'
  };

  var QUERY_KEYS = {
    selectedMarket: 'charlotte_geo_selected'
  };

  var scanTimer = null;
  var editorScanTimer = null;
  var observer = null;
  var isCleanedUp = false;

  function normalizeHost(host) {
    return String(host || '').replace(/^www\./, '').toLowerCase();
  }

  function getStorage() {
    try {
      var testKey = 'charlotte_geo_storage_test';
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return window.localStorage;
    } catch (error) {
      try {
        return window.sessionStorage;
      } catch (sessionError) {
        return null;
      }
    }
  }

  var storage = getStorage();

  function getStorageItem(key) {
    if (!storage) return null;
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setStorageItem(key, value) {
    if (!storage) return;
    try {
      storage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function isValidMarket(market) {
    return Boolean(market && GEO_MARKETS[market]);
  }

  function getCurrentMarket() {
    var currentHost = normalizeHost(window.location.hostname);
    for (var market in GEO_MARKETS) {
      if (Object.prototype.hasOwnProperty.call(GEO_MARKETS, market)) {
        if (GEO_MARKETS[market].domain === currentHost) {
          return market;
        }
      }
    }
    return null;
  }

  function getMarketByUrl(urlValue) {
    var url;
    try {
      url = new URL(urlValue, window.location.origin);
    } catch (error) {
      return null;
    }
    var host = normalizeHost(url.hostname);
    for (var market in GEO_MARKETS) {
      if (Object.prototype.hasOwnProperty.call(GEO_MARKETS, market)) {
        if (GEO_MARKETS[market].domain === host) {
          return market;
        }
      }
    }
    return null;
  }

  function rememberChoice(selectedMarket) {
    if (!isValidMarket(selectedMarket)) return;
    setStorageItem(STORAGE_KEYS.choiceSaved, 'true');
    setStorageItem(STORAGE_KEYS.selectedMarket, selectedMarket);
    for (var market in GEO_MARKETS) {
      if (Object.prototype.hasOwnProperty.call(GEO_MARKETS, market)) {
        setStorageItem(GEO_MARKETS[market].storageKey, 'true');
      }
    }
  }

  function buildRedirectUrl(urlValue, selectedMarket) {
    var url;
    try {
      url = new URL(urlValue, window.location.origin);
    } catch (error) {
      return urlValue;
    }
    if (isValidMarket(selectedMarket)) {
      url.searchParams.set(QUERY_KEYS.selectedMarket, selectedMarket);
    }
    return url.toString();
  }

  function cleanUrlQueryParam(paramName) {
    if (!window.history || !window.history.replaceState) return;
    var url;
    try {
      url = new URL(window.location.href);
    } catch (error) {
      return;
    }
    if (!url.searchParams.has(paramName)) return;
    url.searchParams.delete(paramName);
    window.history.replaceState(
      {},
      document.title,
      url.pathname + url.search + url.hash
    );
  }

  function consumeChoiceFromUrl() {
    var url;
    try {
      url = new URL(window.location.href);
    } catch (error) {
      return;
    }
    var selectedMarket = url.searchParams.get(QUERY_KEYS.selectedMarket);
    if (!isValidMarket(selectedMarket)) return;
    rememberChoice(selectedMarket);
    cleanUrlQueryParam(QUERY_KEYS.selectedMarket);
  }

  function hidePopup(popup) {
    if (!popup) return;
    popup.style.setProperty('display', 'none', 'important');
    popup.style.setProperty('visibility', 'hidden', 'important');
    popup.style.setProperty('opacity', '0', 'important');
    popup.setAttribute('aria-hidden', 'true');

  }

  // Oprește complet tot ce mai rulează — observer, timere, click handler
  function cleanup() {
    if (isCleanedUp) return;
    isCleanedUp = true;

    if (observer) {
      observer.disconnect();
      observer = null;
    }

    clearTimeout(scanTimer);
    scanTimer = null;

    document.removeEventListener('click', onDocumentClick);
    window.removeEventListener('pageshow', onPageShow);
  }

  function isShopifyEditor() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function hideAllPopupsInEditor() {
    var popups = document.querySelectorAll('[data-charlotte-geo]');
    popups.forEach(function (popup) {
      hidePopup(popup);
    });
  }

  function setupEditorMode() {
    hideAllPopupsInEditor();

    var editorObserver = new MutationObserver(function () {
      clearTimeout(editorScanTimer);
      editorScanTimer = setTimeout(function () {
        hideAllPopupsInEditor();
      }, 50);
    });

    editorObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.addEventListener('pageshow', hideAllPopupsInEditor);
  }

  if (isShopifyEditor()) {
    setupEditorMode();
    return;
  }

  function handlePopup(popup) {
    if (!popup) return;

    var popupMarket = popup.getAttribute('data-charlotte-geo');
    var popupConfig = GEO_MARKETS[popupMarket];
    if (!popupConfig) return;

    var currentMarket = getCurrentMarket();
    var isCorrectDomain = currentMarket === popupMarket;
    var wasClosed = getStorageItem(popupConfig.storageKey) === 'true';
    var hasSavedChoice = getStorageItem(STORAGE_KEYS.choiceSaved) === 'true';

    if (isCorrectDomain || wasClosed || hasSavedChoice) {
      hidePopup(popup);
    }
  }

  function areAllPopupsHidden() {
    var popups = document.querySelectorAll('[data-charlotte-geo]');
    if (popups.length === 0) return false;
    var allHidden = true;
    popups.forEach(function (popup) {
      if (popup.getAttribute('aria-hidden') !== 'true') {
        allHidden = false;
      }
    });
    return allHidden;
  }

  function scanPopups() {
    if (isCleanedUp) return;

    var popups = document.querySelectorAll('[data-charlotte-geo]');
    popups.forEach(function (popup) {
      handlePopup(popup);
    });

    var hasVisibleGeo = false;

popups.forEach(function (popup) {
  if (popup.getAttribute('aria-hidden') !== 'true') {
    hasVisibleGeo = true;
  }
});

    // Dacă toate popupurile sunt ascunse sau choice-ul e deja salvat — cleanup complet
    var hasSavedChoice = getStorageItem(STORAGE_KEYS.choiceSaved) === 'true';
    if (hasSavedChoice || areAllPopupsHidden()) {
      cleanup();
    }
  }

  function scheduleScan() {
    if (isCleanedUp) return;
    clearTimeout(scanTimer);
    scanTimer = setTimeout(function () {
      scanPopups();
    }, 50);
  }

  // Handler separat cu referință numită — necesar pentru removeEventListener
  function onDocumentClick(event) {
    if (isCleanedUp) return;

    var closeButton = event.target.closest('[data-charlotte-geo-close]');
    var submitButton = event.target.closest('[data-charlotte-geo-submit]');
    if (!closeButton && !submitButton) return;

    var popup = event.target.closest('[data-charlotte-geo]');
    if (!popup) return;

    var popupMarket = popup.getAttribute('data-charlotte-geo');
    if (!isValidMarket(popupMarket)) return;

    if (closeButton) {
      event.preventDefault();
      rememberChoice(popupMarket);
      hidePopup(popup);
      cleanup();
      return;
    }

    if (submitButton) {
      event.preventDefault();

      var select = popup.querySelector('[data-charlotte-geo-select]');
      if (!select || !select.value) return;

      var selectedMarket = getMarketByUrl(select.value);

      if (!isValidMarket(selectedMarket)) {
        cleanup();
        window.location.href = select.value;
        return;
      }

      rememberChoice(selectedMarket);
      hidePopup(popup);
      cleanup();

      window.location.href = buildRedirectUrl(select.value, selectedMarket);
    }
  }

  // Handler separat cu referință numită — necesar pentru removeEventListener
  function onPageShow() {
    // Dacă choice-ul e deja salvat, nu mai rulăm nimic
    if (isCleanedUp) return;
    var hasSavedChoice = getStorageItem(STORAGE_KEYS.choiceSaved) === 'true';
    if (hasSavedChoice) {
      cleanup();
      return;
    }
    scanPopups();
  }

  // Boot: mai întâi consumăm param-ul din URL, apoi scanăm
  consumeChoiceFromUrl();
  scanPopups();

  // Pornim observer și listeners DOAR dacă scanPopups nu a declanșat cleanup
  if (!isCleanedUp) {
    observer = new MutationObserver(scheduleScan);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    document.addEventListener('click', onDocumentClick);
    window.addEventListener('pageshow', onPageShow);
  }

})();
